import {ICONS} from '../constants/icons';

export const DATA = {
  seo: {
    lang: 'pl',
    title: 'Kontakt',
    description: 'Masz pytania? Skontaktuj się z nami i opisz swój problem. Odezwiemy się tak szybko, jak to możliwe.'
  },

  genericHeading: {
    heading: 'Kontakt',
    breadcrumbsIcon: ICONS.home,
    breadcrumbs: [
      {
        label: 'Home',
        href: '/',
        title: 'Home'
      },
      {
        label: 'Kontakt'
      }
    ]
  },

  contactForm: {
    items: [
      {
        heading: 'Adres',
        description: 'Hello Finance sp. z o.o. <br /> Okopowa 58/72, 14 piętro <br /> 01-042 Warszawa'
      },
      {
        heading: 'Email',
        description:
          '<a href="mailto:contact@hellofinance.pl">contact@hellofinance.pl</a>'
      }
    ]
  },

  map: {
    // eslint-disable-next-line max-len
    embed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2442.770242348586!2d20.977251115770333!3d52.24755676413636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecb75ed10dd7b%3A0x6a133eee93bd70d3!2sKlif%20Tower!5e0!3m2!1spl!2spl!4v1660230696418!5m2!1spl!2spl" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
};
